

class DOMHelper {

    scrollToError = () => {
        const element = document.querySelector('div[class*="error"]');
        if (element) {
            let rect = element.getBoundingClientRect();
            window.scrollTo(0,window.scrollY + rect.top - 100);
        }
    }

}

export default new DOMHelper();